/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { connect } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { saveUserAvatar } from "../../services/usersService";
import CapitalizedText from "../../partials/content/CapitalizedText";
import ResponsiveEllipsis from "../../partials/content/ResponsiveEllipsis";
import { Typography } from "@material-ui/core";
import { Image } from "react-bootstrap";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../partials/layout/Avatar";
import store from "../../store/store";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import DialogLayout from "../../partials/content/DialogLayout";
import { DialogActions } from "@material-ui/core";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../partials/content/BootstrapTooltip";
import withGlobalData from "../../pages/home/common/withGlobalData";
import { actions } from "../../store/ducks/auth.duck";
import { logoutUser } from "../../services/authService";
import { useGlobalData } from "../../../provider/GlobalDataProvider";

function UserProfile({ history, showHi, showAvatar, showBadge }) {
  const { companyProfile, user, reload, setReload } = useGlobalData();
  const [openUploadImage, setOpenUploadImage] = useState(false);
  const [imageSource, setImageSource] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [imageType, setImageType] = useState(null);
  const [imageCrop, setImageCrop] = useState({
    unit: "%",
    aspect: 1 / 1,
  });
  const [croppedImageUrl, setCroppedImageUrl] = useState(null);
  const imageRef = useRef(null);
  const fileInput = useRef(null);

  useEffect(() => {}, [reload]);

  return (
    <React.Fragment>
      <Dropdown
        className="kt-header__topbar-item kt-header__topbar-item--user"
        drop="down"
        alignRight
      >
        <Dropdown.Toggle
          as={HeaderDropdownToggle}
          id="dropdown-toggle-user-profile"
        >
          <div className="kt-header__topbar-user">
            {companyProfile.companyProfileLogo &&
            companyProfile.companyProfileLogo.length > 0 ? (
              <React.Fragment>
                <span className="kt-header__topbar-partnerlogo">
                  <Typography align="center">
                    <Image
                      src={
                        companyProfile.companyProfileLogo.length === 0
                          ? null
                          : companyProfile.companyProfileLogo[0].imagePath
                      }
                      style={{
                        maxHeight: "2rem",
                        borderRadius: "0px",
                      }}
                      alt="Company Profile Logo"
                      fluid
                    />
                  </Typography>
                </span>
              </React.Fragment>
            ) : null}
            {showHi && (
              <span className="kt-header__topbar-welcome kt-hidden-mobile">
                Hi,
              </span>
            )}

            {showHi && (
              <span className="kt-header__topbar-username kt-hidden-mobile">
                <CapitalizedText text={user.fullName} />
              </span>
            )}

            {showAvatar && (
              <React.Fragment>
                {user.userImage && user.userImage.length > 0 ? (
                  <Image
                    src={
                      user.userImage.length === null
                        ? createImageFromInitials(
                            150,
                            user.fullName,
                            getRandomColor()
                          )
                        : user.userImage[0].imagePath
                    }
                    roundedCircle
                    alt="Avatar"
                    fluid
                  />
                ) : (
                  <Image
                    src={createImageFromInitials(
                      150,
                      user.fullName,
                      getRandomColor()
                    )}
                    roundedCircle
                    alt="Avatar"
                    fluid
                  />
                )}
              </React.Fragment>
            )}

            {showBadge && (
              <span className="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
                {/* TODO: Should get from currentUser */}
                <CapitalizedText text={user.fullName} />
              </span>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-xl">
          {/** ClassName should be 'dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
          <div
            className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/450.jpg")})`,
            }}
          >
            <div className="kt-user-card__avatar">
              {/*<img alt="Pic" className="kt-hidden" src="" />
              <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                S
          </span>*/}
              {user.userImage && user.userImage.length > 0 ? (
                <React.Fragment>
                  <Typography align="center">
                    <Image
                      src={
                        user.userImage.length === null
                          ? createImageFromInitials(
                              150,
                              user.fullName,
                              getRandomColor()
                            )
                          : user.userImage[0].imagePath
                      }
                      roundedCircle
                      alt="Avatar"
                      fluid
                    />
                  </Typography>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography align="center">
                    <Image
                      src={createImageFromInitials(
                        150,
                        user.fullName,
                        getRandomColor()
                      )}
                      roundedCircle
                      alt="Avatar"
                      fluid
                    />
                  </Typography>
                </React.Fragment>
              )}
            </div>
            <div className="kt-user-card__avatarbutton">
              <BootstrapTooltip title="Upload Avatar">
                <button
                  type="button"
                  onClick={handleOpenUploadImage}
                  className="btn btn-icon btn-label-success btn-circle btn-sm"
                >
                  <i className="fas fa-camera"></i>
                </button>
              </BootstrapTooltip>
            </div>
            <div className="kt-user-card__name">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <ResponsiveEllipsis text={user.fullName} maxLine="1" />
                  {user.groupName ? (
                    <div className="kt-user-card__subname">
                      <ResponsiveEllipsis text={user.groupName} maxLine="1" />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="kt-user-card__badge">
              {user.ID === 1 ? (
                <Badge variant="dark">Admin User</Badge>
              ) : (
                <Badge variant="success">Verified User</Badge>
              )}
            </div>
          </div>
          <div className="kt-notification">
            <Link
              className="kt-notification__item"
              to="/users/profile"
              onClick={() => {
                document.body.click();
              }}
            >
              <div className="kt-notification__item-icon">
                <i className="fas fa-address-card kt-font-brand" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bolder">
                  My Profile
                </div>
                <div className="kt-notification__item-time">
                  Account settings and more
                </div>
              </div>
            </Link>

            <Link
              className="kt-notification__item"
              to="/users/messages/0"
              onClick={() => {
                document.body.click();
              }}
            >
              <div className="kt-notification__item-icon">
                <i className="fas fa-mail-bulk kt-font-success" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bolder">
                  My Messages
                  {user.unreadMessages > 0 ? (
                    <BootstrapTooltip title="Unread Messages">
                      <Badge className="badge-notif mx-2" variant="danger">
                        {user.unreadMessages < 100
                          ? user.unreadMessages
                          : "99+"}
                      </Badge>
                    </BootstrapTooltip>
                  ) : null}
                </div>
                <div className="kt-notification__item-time">
                  Communication channel with the teams
                </div>
              </div>
            </Link>
            <Link
              className="kt-notification__item"
              to="/users/pending-approvals/0"
              onClick={() => {
                document.body.click();
              }}
            >
              <div className="kt-notification__item-icon">
                <i className="fas fa-diagnoses kt-font-primary" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bolder">
                  My Pending Approvals
                  {user.pendingApprovals > 0 ? (
                    <BootstrapTooltip title="Pending Approvals">
                      <Badge className="badge-notif mx-2" variant="danger">
                        {user.pendingApprovals < 100
                          ? user.pendingApprovals
                          : "99+"}
                      </Badge>
                    </BootstrapTooltip>
                  ) : null}
                </div>
                <div className="kt-notification__item-time">
                  List of document approval requests
                </div>
              </div>
            </Link>
            <Link
              className="kt-notification__item"
              to="/users/tasks"
              onClick={() => {
                document.body.click();
              }}
            >
              <div className="kt-notification__item-icon">
                <i className="fas fa-tasks kt-font-info" />
              </div>
              <div className="kt-notification__item-details">
                <div className="kt-notification__item-title kt-font-bolder">
                  My Tasks
                  {user.unfinishedTasks > 0 ? (
                    <BootstrapTooltip title="Unfinished Tasks">
                      <Badge className="badge-notif mx-2" variant="danger">
                        {user.unfinishedTasks < 100
                          ? user.unfinishedTasks
                          : "99+"}
                      </Badge>
                    </BootstrapTooltip>
                  ) : null}
                </div>
                <div className="kt-notification__item-time">
                  A board of assignments
                </div>
              </div>
            </Link>
            <div className="kt-notification__custom">
              <button
                className="btn btn-label-brand btn-md btn-pill btn-bold"
                onClick={() => {
                  logoutUser().then((response) => {
                    store.dispatch(actions.logout());
                    history.push("/auth/login");
                  });
                }}
              >
                <i className="fas fa-sign-out-alt"></i>
                Sign Out
              </button>
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <DialogLayout
        open={openUploadImage}
        title="Upload Avatar"
        onCloseDialog={handleCloseUploadImage}
        maxWIdth={fileInput.current != null ? "md" : "sm"}
      >
        <input
          className="form-control"
          type="file"
          accept="image/*"
          ref={fileInput}
          onChange={handleSelectImage}
          style={{ display: "none" }}
        />
        <div className="d-flex justify-content-center mb-5">
          <div className="column">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <React.Fragment>
                <Typography align="center">
                  <button
                    className="btn btn-primary btn-md btn-pill btn-bold mb-1"
                    onClick={() => fileInput.current.click()}
                  >
                    <i className="fas fa-mouse-pointer"></i>
                    Select File
                  </button>
                </Typography>
              </React.Fragment>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              {fileInput.current != null ? (
                <React.Fragment>
                  <Typography align="center">{imageName}</Typography>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography align="center">No file chosen</Typography>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          {fileInput.current != null ? (
            <React.Fragment>
              <div className="col-6">
                <Card>
                  <Card.Header>
                    <Typography align="center" className="mb-1">
                      <strong>Crop Below Image</strong>
                    </Typography>
                  </Card.Header>
                  <Card.Body>
                    <Typography component="div" align="center">
                      {imageSource && (
                        <ReactCrop
                          src={imageSource}
                          crop={imageCrop}
                          ruleOfThirds={true}
                          circularCrop={true}
                          onImageLoaded={handleImageLoaded}
                          onComplete={handleCropComplete}
                          onChange={handleCropChange}
                        />
                      )}
                    </Typography>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-6">
                <Card>
                  <Card.Header>
                    <Typography align="center" className="mb-1">
                      <strong> Cropped Image Preview</strong>
                    </Typography>
                  </Card.Header>
                  <Card.Body>
                    <Typography component="div" align="center">
                      {croppedImageUrl != null ? (
                        <Image
                          src={croppedImageUrl}
                          roundedCircle
                          alt="Crop"
                          fluid
                          style={{
                            width: "50%",
                            height: "50%",
                          }}
                        />
                      ) : (
                        <Image
                          src="../../../invifo/illustrations/blank_image.png"
                          roundedCircle
                          alt="Crop"
                          fluid
                          style={{
                            width: "50%",
                            height: "50%",
                          }}
                        />
                      )}
                    </Typography>
                  </Card.Body>
                </Card>
              </div>
            </React.Fragment>
          ) : null}
        </div>
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={handleCloseUploadImage}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
          <button
            type="button"
            className="btn btn-success btn-md btn-pill btn-bold"
            onClick={async () => {
              if (croppedImageUrl != null && fileInput.current != null) {
                const filesData = new FormData();
                filesData.append("base64", croppedImageUrl);
                filesData.append("imageName", imageName);
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                })
                  .fire({
                    title: "Are you sure want to upload this Avatar ?",
                    text:
                      "Please note that you are responsible for this action",
                    icon: "question",
                    showCloseButton: true,
                    showCancelButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, upload it`,
                    cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                    reverseButtons: true,
                  })
                  .then((result) => {
                    if (result.isConfirmed) {
                      saveUserAvatar(filesData).then((response) => {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Uploaded",
                          html: response.data.message,
                          icon: "success",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                        handleCloseUploadImage();
                        setReload(reload + 1);
                      });
                    } else if (result.dismiss === Swal.DismissReason.cancel) {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Cancelled",
                        text: "No change has been made",
                        icon: "info",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                    }
                  });
              } else {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Failed",
                  text: "Upload & Crop your Avatar first before saving",
                  icon: "error",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            }}
          >
            <i className="fas fa-upload"></i>
            Upload
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function handleOpenUploadImage() {
    setImageCrop({
      unit: "%",
      aspect: 1 / 1,
    });
    setImageSource(null);
    setImageName(null);
    setImageType(null);
    setCroppedImageUrl(null);
    setOpenUploadImage(true);
  }

  async function handleCloseUploadImage() {
    setOpenUploadImage(false);
  }

  async function handleSelectImage(e) {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        setImageSource(reader.result);
        setImageName(fileInput.current.files[0].name);
        setImageType(fileInput.current.files[0].type);
      });
      reader.readAsDataURL(e.target.files[0]);
      setCroppedImageUrl(null);
    }
  }

  async function handleImageLoaded(image) {
    const aspect = 1 / 1;
    const width =
      image.width / aspect < image.height * aspect
        ? 100
        : ((image.height * aspect) / image.width) * 100;
    const height =
      image.width / aspect > image.height * aspect
        ? 100
        : (image.width / aspect / image.height) * 100;
    const y = (100 - height) / 2;
    const x = (100 - width) / 2;
    setImageCrop({ unit: "%", aspect: aspect, width: width, x: x, y: y });
    imageRef.current = image;
    return false; // Return false when setting crop state in here.
  }

  async function handleCropComplete(crop) {
    makeClientCrop(crop);
  }

  async function handleCropChange(imageCrop, percentCrop) {
    setImageCrop(percentCrop);
  }

  async function makeClientCrop(crop) {
    if (imageRef.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        "newFile.jpeg"
      );
      setCroppedImageUrl(croppedImageUrl);
    }
  }

  async function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.ceil(crop.width * scaleX);
    canvas.height = Math.ceil(crop.height * scaleY);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );
    return canvas.toDataURL(imageType);
  }
}

const mapStateToProps = ({ auth: { user } }) => ({
  user,
});

export default connect(mapStateToProps)(withGlobalData(UserProfile));
